import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  state
});

class ErrorPage extends Component {
  goHomeClick = () => {
    this.props.history.push("/");
  };

  render() {
    let link = this.props.location.search.split("?")[1];
    let text = "";

    if (link === "500") {
      text = "Не заполнены атрибуты кинотеатра или города!";
    } else if (link === "404") {
      text = "page 404";
    }
    return (
      <Fragment>
        <div className="text-error">
          <h1>{text}</h1>
        </div>

        <div className="goHome" onClick={this.goHomeClick}>
          Вернуться на главную
        </div>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps)(ErrorPage);



// WEBPACK FOOTER //
// ./src/containers/ErrorPage.jsx